import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  CONTACT_US_ROUTE,
  PURCHASE_ROUTE,
  TICKETS_ROUTE,
  GIFTCARD_BALANCE_ROUTE,
  MY_CLUBS_ROUTE,
  POINTS_ROUTE,
  MENU_ROUTE,
  DATA_ROUTE,
  HOME_ROUTE,
  PAY_CARD,
  RETURNS_ROUTE,
} from '../../constants/Routes';
import {
  showContactUs,
  showMyData,
  showMyPurchases,
  showMyTickets,
  showGiftcardBalance,
  showMyClubs,
  showMyPoints,
  showReturns,
} from '../../constants/Visible';
import GiftcardBalance from '../views/saldo-giftcard/GiftcardBalance';
import MyClubs from '../views/mis-clubes/MyClubs';
import MobileNavigation from '../layout/mobile/MobileNavigation';
import DataRoutes from '../views/mis-datos/DataRoutes';
import PurchasesRoutes from '../views/mis-compras/PurchasesRoutes';
import PointsRouter from '../views/mis-puntos/PointsRoutes';
import TicketRoutes from '../views/mis-solicitudes/TicketRoutes';
import ContactUs from '../views/contactanos/ContactUs';
import PayCardRoutes from '../views/pagar-tarjeta/PayCardRoutes';
import Returns from '../views/devoluciones/Returns';

const MainContent = ({ ...props }) => {
  const { mobile } = props;
  return (
    <Switch>
      <Route exact path={HOME_ROUTE}>
        {mobile ? <Redirect to={MENU_ROUTE} /> : <Redirect to={DATA_ROUTE} />}
      </Route>
      {showMyData === 'on' && (
        <Route path={DATA_ROUTE}>
          <DataRoutes mobile={mobile} />
        </Route>
      )}
      {showMyPurchases === 'on' && (
        <Route path={PURCHASE_ROUTE}>
          <PurchasesRoutes mobile={mobile} />
        </Route>
      )}
      {showMyTickets === 'on' && (
        <Route path={TICKETS_ROUTE}>
          <TicketRoutes mobile={mobile} />
        </Route>
      )}
      {showGiftcardBalance === 'on' && (
        <Route exact path={GIFTCARD_BALANCE_ROUTE}>
          <GiftcardBalance path={GIFTCARD_BALANCE_ROUTE} mobile={mobile} />
        </Route>
      )}
      {showMyClubs === 'on' && (
        <Route exact path={MY_CLUBS_ROUTE}>
          <MyClubs path={MY_CLUBS_ROUTE} mobile={mobile} />
        </Route>
      )}
      {showMyPoints === 'on' && (
        <Route path={POINTS_ROUTE}>
          <PointsRouter mobile={mobile} />
        </Route>
      )}
      {showContactUs === 'on' && (
        <Route path={CONTACT_US_ROUTE}>
          <ContactUs mobile={mobile} />
        </Route>
      )}
      <Route path={PAY_CARD}>
        <PayCardRoutes mobile={mobile} />
      </Route>
      {mobile && (
        <Route exact path={MENU_ROUTE}>
          <MobileNavigation />
        </Route>
      )}
      {showReturns === 'on' && (
        <Route path={RETURNS_ROUTE}>
          <Returns mobile={mobile} />
        </Route>
      )}
    </Switch>
  );
};

MainContent.propTypes = {
  mobile: PropTypes.bool,
};

export default MainContent;
